

import { HeadsetMicRounded } from "@material-ui/icons";
import Async from "../../components/Async";
import { appConstants } from "../../domain/constant/app.constant";

const AuthGuard = Async(() => import('../auth.guard'));

const routes = {
    orbita: {
        id: 'orbita',
        name: 'Orbita',
        icon: <HeadsetMicRounded />,
        path: appConstants.orbitaTicketsUrl,
        roles: ['orbita-agent', 'orbita-admin', 'seller'],
        isLink: true,
        guard: AuthGuard,
    },
}

const pages = Object.values(routes);

export default {
    routes,
    pages
}
